var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReceipt = function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26BAB9",
    d: "M16.5 4.5v1.815c0 1.185-.75 1.935-1.935 1.935H12V3.008c0-.833.682-1.508 1.515-1.508a3.02 3.02 0 0 1 2.108.878c.54.547.877 1.297.877 2.122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#26BAB9",
    d: "M1.5 5.25v10.5c0 .622.705.975 1.2.6l1.282-.96c.3-.225.72-.195.99.075l1.245 1.253a.756.756 0 0 0 1.066 0l1.26-1.26a.74.74 0 0 1 .975-.068l1.282.96a.752.752 0 0 0 1.2-.6V3c0-.825.675-1.5 1.5-1.5h-9c-2.25 0-3 1.342-3 3z",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#26BAB9",
    d: "M9 7.313H4.5a.567.567 0 0 1-.562-.563c0-.308.254-.562.562-.562H9c.307 0 .563.255.563.562A.567.567 0 0 1 9 7.313M8.438 10.313H5.062A.567.567 0 0 1 4.5 9.75c0-.307.255-.562.563-.562h3.375c.307 0 .562.255.562.562a.567.567 0 0 1-.562.563"
  })));
};
export default SvgReceipt;